import Analytics from '@/utils/analytics';
import { FocusSource, useComponentFocus } from './use-component-focus';
import { PromotionListOption } from './use-promotion-list-options';
import { useCallback, useRef, useState } from 'react';
import { ViewToken } from 'react-native';

function* defaultPromotionGenerator(
  viewableItems: ViewToken<PromotionListOption>[],
) {
  for (const viewableItem of viewableItems) {
    yield viewableItem.item.metadata!.promotion.uuid;
  }
}

interface Options {
  promotionGenerator?: (viewableItems: ViewToken[]) => IterableIterator<string>;
  trackingLocation: string;
}

export const useTrackPromotionImpressions = ({
  promotionGenerator = defaultPromotionGenerator,
  trackingLocation,
}: Options) => {
  const [promotionsImpressions, setPromotionsImpressions] = useState<
    Set<string>
  >(new Set());

  useComponentFocus({
    onFocus: useCallback(
      (focusSource: FocusSource) => {
        if (focusSource === FocusSource.Navigation) {
          setPromotionsImpressions(new Set());
        }
      },
      [setPromotionsImpressions],
    ),
  });

  const onViewableItemsChangedRef = useRef(
    ({ viewableItems }: { viewableItems: ViewToken[] }) => {
      for (const promotionUUID of promotionGenerator(viewableItems)) {
        if (!promotionsImpressions.has(promotionUUID)) {
          promotionsImpressions.add(promotionUUID);
          Analytics.track('promotions.view', {
            location: trackingLocation,
            promotionUUID,
          });
        }
      }
    },
  );

  return {
    onViewableItemsChanged: onViewableItemsChangedRef.current,
  };
};
